import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs, deleteDoc, doc, updateDoc, query, where } from 'firebase/firestore'; // orderBy sildik kanka
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { Plus, Trash2, Edit3, Image as ImageIcon, Loader2, CheckCircle, X, FlaskConical, Beaker, AlignLeft } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { db, storage } from '../firebase/firebase-config';

const AdditivesManager = () => {
  const [products, setProducts] = useState([]);
  const [editingId, setEditingId] = useState(null);
  
  const initialProductState = { 
    name: '', categoryName: 'Yem Katkıları', subType: 'katki', isBestSeller: false, type: '', weight: '', imageUrl: '', description: '',
    analysis: { hamProtein: '', hamYag: '', hamSeluloz: '', hamKul: '', rutubet: '', nisasta: '', kalsiyum: '', fosfor: '', sodyum: '', aflatoksin: '', metabolikEnerji: '' }
  };

  const [newProduct, setNewProduct] = useState(initialProductState);
  const [loading, setLoading] = useState({ submit: false, img: false });
  const [status, setStatus] = useState('');

  const fetchAdditives = async () => {
    try {
      // Kankam hataya sebep olan orderBy kısmını buradan kaldırdım
      const q = query(collection(db, "products"), where("categoryName", "==", "Yem Katkıları"));
      const snap = await getDocs(q);
      
      const docs = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      // SIRALAMAYI BURADA YAPIYORUZ (Firebase'e gerek kalmadı)
      // En yeni eklenen en üstte görünsün diye:
      const sortedDocs = docs.sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds);
      
      setProducts(sortedDocs);
    } catch (err) {
      console.error("Veri çekme hatası:", err);
    }
  };

  useEffect(() => { fetchAdditives(); }, []);

  const handleUpload = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    setLoading(prev => ({ ...prev, img: true }));
    const sRef = ref(storage, `additives/${Date.now()}_${selectedFile.name}`);
    try {
      await uploadBytes(sRef, selectedFile);
      const url = await getDownloadURL(sRef);
      setNewProduct(prev => ({ ...prev, imageUrl: url }));
    } catch (err) { console.error(err); }
    setLoading(prev => ({ ...prev, img: false }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(prev => ({ ...prev, submit: true }));
    try {
      const productData = { ...newProduct, updatedAt: new Date() };
      if (editingId) {
        await updateDoc(doc(db, "products", editingId), productData);
        setStatus('updated');
      } else {
        await addDoc(collection(db, "products"), { ...productData, createdAt: new Date() });
        setStatus('success');
      }
      setNewProduct(initialProductState);
      setEditingId(null);
      fetchAdditives();
      setTimeout(() => setStatus(''), 3000);
    } catch (err) { console.error(err); }
    setLoading(prev => ({ ...prev, submit: false }));
  };

  const handleDelete = async (id) => {
    if (window.confirm("Bu katkı ürününü silmek istediğine emin misin?")) {
      await deleteDoc(doc(db, "products", id));
      fetchAdditives();
    }
  };

  return (
    <div className="panel-box">
      <AnimatePresence>{status && <div className="status-toast"><CheckCircle size={22} /> <span>İşlem Başarılı!</span></div>}</AnimatePresence>

      <div className="admin-header-flex">
        <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><FlaskConical size={24} color="#f59e0b" /> {editingId ? 'Yem Katkısını Düzenle' : 'Yeni Yem Katkısı Ekle'}</h3>
      </div>

      <form className="admin-form" onSubmit={handleSave}>
        <div className="product-upload">
          {newProduct.imageUrl ? <img src={newProduct.imageUrl} alt="Önizleme" /> : <div className="placeholder-content"><ImageIcon size={32} /><span>Görsel Yükle</span></div>}
          <input type="file" onChange={handleUpload} id="add-img" hidden />
          <label htmlFor="add-img" className="full-click-label"></label>
          {loading.img && <div className="loading-overlay-abs"><Loader2 className="animate-spin" /></div>}
        </div>

        <div className="form-right-content">
          <div className="admin-form-grid">
            <div className="form-group"><label>Ürün Adı</label><input type="text" value={newProduct.name} onChange={e => setNewProduct({...newProduct, name: e.target.value})} required placeholder="Örn: Bigma Vitamin Paketi" /></div>
            <div className="form-group"><label>Form (Sıvı/Toz)</label><input type="text" value={newProduct.type} onChange={e => setNewProduct({...newProduct, type: e.target.value})} placeholder="Örn: Toz" /></div>
            <div className="form-group"><label>Ağırlık/Hacim</label><input type="text" value={newProduct.weight} onChange={e => setNewProduct({...newProduct, weight: e.target.value})} placeholder="Örn: 5 KG" /></div>
          </div>

          <div className="analysis-inputs-section">
            <div className="section-title-mini"><Beaker size={16}/> Analiz Değerleri</div>
            <div className="analysis-grid">
              <div className="form-group-mini"><label>Enerji (ME)</label><input type="text" value={newProduct.analysis.metabolikEnerji} onChange={e => setNewProduct({...newProduct, analysis: {...newProduct.analysis, metabolikEnerji: e.target.value}})} /></div>
              <div className="form-group-mini"><label>Ham Protein</label><input type="text" value={newProduct.analysis.hamProtein} onChange={e => setNewProduct({...newProduct, analysis: {...newProduct.analysis, hamProtein: e.target.value}})} /></div>
              <div className="form-group-mini"><label>Ham Yağ</label><input type="text" value={newProduct.analysis.hamYag} onChange={e => setNewProduct({...newProduct, analysis: {...newProduct.analysis, hamYag: e.target.value}})} /></div>
              <div className="form-group-mini"><label>Ham Selüloz</label><input type="text" value={newProduct.analysis.hamSeluloz} onChange={e => setNewProduct({...newProduct, analysis: {...newProduct.analysis, hamSeluloz: e.target.value}})} /></div>
              <div className="form-group-mini"><label>Ham Kül</label><input type="text" value={newProduct.analysis.hamKul} onChange={e => setNewProduct({...newProduct, analysis: {...newProduct.analysis, hamKul: e.target.value}})} /></div>
              <div className="form-group-mini"><label>Rutubet</label><input type="text" value={newProduct.analysis.rutubet} onChange={e => setNewProduct({...newProduct, analysis: {...newProduct.analysis, rutubet: e.target.value}})} /></div>
            </div>
          </div>

          <div className="form-group full-width-field">
            <label><AlignLeft size={16}/> Detaylı Açıklama</label>
            <textarea value={newProduct.description} onChange={e => setNewProduct({...newProduct, description: e.target.value})} rows={3} className="form-textarea" />
          </div>

          <div className="form-actions">
             {editingId && <button type="button" className="cancel-btn" onClick={() => {setNewProduct(initialProductState); setEditingId(null);}}><X size={18}/> İptal</button>}
             <button type="submit" className="save-btn" disabled={loading.submit}>
               {loading.submit ? <Loader2 className="animate-spin" /> : (editingId ? "Güncelle" : "Katkı Maddesini Kaydet")}
             </button>
          </div>
        </div>
      </form>

      <div className="admin-list-section">
        <h4>Sistemdeki Yem Katkıları ({products.length})</h4>
        <div className="admin-data-list">
          {products.map(prod => (
            <div key={prod.id} className="admin-list-item">
              <img src={prod.imageUrl} alt={prod.name} className="list-thumb" />
              <div className="list-info"><h5>{prod.name}</h5><span>{prod.weight}</span></div>
              <div className="list-actions">
                <button className="edit-mini-btn" onClick={() => {setNewProduct(prod); setEditingId(prod.id); window.scrollTo(0,0);}}><Edit3 size={16}/></button>
                <button className="delete-mini-btn" onClick={() => handleDelete(prod.id)}><Trash2 size={16}/></button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdditivesManager;